import * as systemServ from "../services/systemService";

export default {
  namespaced: true,
  state: {
    isLoading: false, //是否正在进行远程处理
    system: {},
    isFetched: false
  },
  mutations: {
    setSystem(state, payload) {
      state.system = {
        ...state.system,
        ...payload
      };
      state.isFetched = true;
    },
    setIsLoaing(state, payload) {
      state.isLoading = payload;
    }
  },
  actions: {
    async fetchSystem(context) {
      if (context.state.isFetched) {
        return;
      }
      context.commit("setIsLoaing", true);
      const resp = await systemServ.getSystem();
      context.commit("setIsLoaing", false);
      context.commit("setSystem", resp.data);
      return resp;
    },
    async updateSystem(context, systemObj) {
      if (!systemObj) {
        return;
      }
      context.commit("setIsLoaing", true);
      const resp = await systemServ.updateSystem(systemObj);
      context.commit("setIsLoaing", false);
      context.commit("setSystem", systemObj);
      return resp;
    }
  }
};
